import { connect } from 'react-redux';

import { getUnitsExecutionState } from '../../../reducers/analyticsApp';
import FunnelExecutionDetails from '../../../components/dashboards/preview/FunnelExecutionDetails';

const mapStateToProps = (state, { unit }) => {
  const unitExecute = getUnitsExecutionState(state)[unit.id];
  const conversionIntervalIsNone = unit.compose.funnels.options.conversionInterval === 'NONE';
  const { result } = unitExecute;

  return {
    chart: (result || {}).chart,
    steps: unit.compose.funnels.funnel.steps,
    perStepClosingRangeEnabled: true,
    conversionIntervalIsNone,
    ...(result && { stepCounters: result.steps }),
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FunnelExecutionDetails);
